import { Box, styled, Tab, Tabs, Typography } from '@mui/material';
import QuickReconcile from './QuickReconcile';
import { ActionRef } from 'further-types/lp/action';
import { CurrencyCode } from 'further-types/lp/vehicle';
import CreateTransfer from './CreateTransfer';
import { useFormContext } from 'react-hook-form';
import { FormValues } from '..';

export enum BankOperationActionsMode {
  QuickReconcile,
  CreateTransfer,
}

const ActionsContainer = styled(Box)({
  alignSelf: 'flex-end',
});

const StyledTab = styled(Tab)({
  '& .MuiTypography-root': {
    fontSize: '11px',
    fontWeight: 500,
    letterSpacing: 0.4,
  },
});

type Props = {
  bankAccountOperationId: string;
  isOutgoingTransaction: boolean;
  onFindAndMatch: (
    bankAccountOperationId: string,
    transactionId?: string,
  ) => void;
  matchingReconcilableTransactions: Array<{
    id: string;
    unreconciledAmountTcy: number;
    counterpartyLabel: string;
    actionRef: ActionRef;
    currencyCode: CurrencyCode;
  }>;
};

const BankOperationActions: React.FC<Props> = ({
  isOutgoingTransaction,
  bankAccountOperationId,
  onFindAndMatch,
  matchingReconcilableTransactions,
}) => {
  const { watch, setValue } = useFormContext<FormValues>();

  const handleShowFindAndMatch = (transactionId?: string) => {
    onFindAndMatch(bankAccountOperationId, transactionId);
  };

  const handleTabChange = (
    _: unknown,
    selectedTab: BankOperationActionsMode,
  ) => {
    setValue('mode', selectedTab);
  };

  const actionsMode = watch('mode');

  return (
    <ActionsContainer>
      <Tabs
        value={actionsMode}
        onChange={handleTabChange}
        indicatorColor="primary"
        textColor="primary"
      >
        <StyledTab
          value={BankOperationActionsMode.QuickReconcile}
          label={<Typography variant="body2">MATCH</Typography>}
        />
        {isOutgoingTransaction && (
          <StyledTab
            value={BankOperationActionsMode.CreateTransfer}
            label={<Typography variant="caption">CREATE TRANSFER</Typography>}
          />
        )}
      </Tabs>
      {actionsMode === BankOperationActionsMode.QuickReconcile && (
        <QuickReconcile
          matchingReconcilableTransactions={matchingReconcilableTransactions}
          onFindAndMatch={handleShowFindAndMatch}
        />
      )}
      {isOutgoingTransaction &&
        actionsMode === BankOperationActionsMode.CreateTransfer && (
          <CreateTransfer />
        )}
    </ActionsContainer>
  );
};

export default BankOperationActions;
